import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/explore.scss';

function ExploreHero({
	image,
	eyebrow,
	title,
	lead,
	primaryCta,
	secondaryCta,
	compact = false,
	booking = false,
}) {
	return (
		<header className={`explore-hero${compact ? ' explore-hero--compact' : ''}${booking ? ' explore-hero--booking' : ''}`}>
			<div className="explore-hero__bg" aria-hidden="true">
				<img src={image} alt="" fetchPriority="high" />
			</div>
			<div className="explore-hero__overlay" aria-hidden="true" />
			<div className="container explore-hero__content">
				{eyebrow && <span className="explore-hero__eyebrow">{eyebrow}</span>}
				<h1 className="explore-hero__title">{title}</h1>
				{lead && <p className="explore-hero__lead">{lead}</p>}
				{(primaryCta || secondaryCta) && (
					<div className="explore-hero__actions">
						{primaryCta && (
							<Link to={primaryCta.to} className="explore-hero__cta explore-hero__cta--primary">
								{primaryCta.label}
							</Link>
						)}
						{secondaryCta && (
							<Link to={secondaryCta.to} className="explore-hero__cta explore-hero__cta--ghost">
								{secondaryCta.label}
							</Link>
						)}
					</div>
				)}
			</div>
		</header>
	);
}

export default ExploreHero;
